import { space, tok, tokPx } from '@sunwebgroup/ui-components'
import { Typography } from '@sunwebgroup/ui-components/uds'
import React from 'react'
import { styled } from 'styled-components'

const RatingBubble = styled.div`
  padding: ${tokPx('components_tag_m_padding_top')}; ${tokPx('components_tag_m_padding_right')};
  background-color: ${tok('primitives_color_green_50')};
  margin-right: ${space('primitives_space_8')};
  border-radius: ${tokPx('components_tag_m_corner_radius')};
  color: ${tok('primitives_color_green_550')};
`
const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

interface ReviewScoreProps {
  rating: string
  scoreLabel: string
}

export function ReviewScore({ rating, scoreLabel }: ReviewScoreProps) {
  return (
    <Wrapper>
      <RatingBubble>
        <Typography $variant="body-s-bold-flat">{rating}</Typography>
      </RatingBubble>
      <Typography $variant="body-m-bold-tight">{scoreLabel}</Typography>
    </Wrapper>
  )
}
